import * as yup from 'yup';

/** Standard schema to validate Russian TIN (Taxpayer Idendification Number, rus. "ИНН") */
export const russianTinSchema = yup
  .string()
  .matches(/^\d{10,12}$/im, 'ИНН должен состоять из 10 или 12 цифр');
